import SearchBar from "ui/common/components/input/SearchBar/SearchBar";
import { QuerySearchBarProps } from "./QuerySearchBar.types";
import useSearchParam from "ui/common/hooks/useSearchParam";
import { useEffect, useRef } from "react";

const QuerySearchBar = (props: QuerySearchBarProps): JSX.Element => {
    const [searchParam, setSearchParam] = useSearchParam("query");
    const defaultValue = useRef<string | undefined>();
    const modified = useRef(false);

    useEffect(() => {
        if (defaultValue.current === undefined && !modified.current && searchParam !== undefined) {
            defaultValue.current = searchParam;
        }
    }, [searchParam]);

    const handleChange = (value: string) => {
        if (!modified.current) modified.current = true;
        setSearchParam(value);
    };

    return <SearchBar key={defaultValue.current} defaultValue={defaultValue.current} onChange={handleChange} {...props} />;
};

export default QuerySearchBar;
